import React from 'react';
import { CartoonPortrait } from './CartoonPortrait';
interface FigureProps {
  className?: string;
}
export function MiddleChildFigure({
  className = ''
}: FigureProps) {
  return <CartoonPortrait className={className} label="Cartoon portrait of a balanced, easygoing middle child" disc="#A1D4FD" skin="#C79374" skinShade="#B27E60" hair="#2F2233" shirt="#6E4A9E" hairStyle="wavyLong" mouth="smile" tilt={-5} data-id="element-70" data-mp="3818qb3w0kxmr" />;
}